export default {
  'pages.home.heroTitle': 'Analyze, clone or generate viral shoppable videos',
  'pages.home.mode.video': 'Generate Video',
  'pages.home.mode.image': 'Generate Image',
  'pages.home.myGenerated': 'My generated {type}',
  'pages.home.assetType.video': 'videos',
  'pages.home.assetType.image': 'images',
};
